import React from 'react';
import { Link } from 'react-router-dom';

function CategoryButtons({ categories }) {
  return (
    <>
    <h5 className="button-margin">List Jobs by Category</h5>
      <ul
        className="searchbar-category-list tw-flex tw-items-center tw-mt-2"
        data-testid="rwm-category-list"
      >
        {categories.map((category) => (
          <li key={category.id} className="tw-mt-2 tw-mr-2 tw-text-sm border-rounded-light">
            <Link
              className="blue-text"
              data-testid={`rwm-category-pill-${category.id}`}
              to={`/jobs?category_id=${category.id}`}
            >
              {category.name}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}

export default CategoryButtons;